import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-visitor-token-expired-dialog-component',
  templateUrl: './visitor-token-expired-dialog-component.component.html',
  styleUrl: './visitor-token-expired-dialog-component.component.scss'
})
export class VisitorTokenExpiredDialogComponentComponent {
  countdown: number = 5; // Set the countdown time in seconds
  interval: any;
  constructor(
    public dialogRef: MatDialogRef<VisitorTokenExpiredDialogComponentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    clearInterval(this.interval);
  }
}
